import * as React from 'react';

// COMPONENTS
import Button from '../../components/Button';
import CircleImage from '../../components/CircleImage';

// ICONS
import { ReactComponent as ArrowLeftIcon } from '../../assets/svg/chevron-left.svg';

// TYPES
import { SafetyChecklists } from './SafetyChecklistsSubmit';

interface StepTwoTypes {
	safetyChecklistsFormData: SafetyChecklists;
	setActiveStep: React.Dispatch<React.SetStateAction<string>>;
	formSubmitHandler: () => void;
}

const StepTwo: React.FC<StepTwoTypes> = ({ safetyChecklistsFormData, setActiveStep, formSubmitHandler }) => {
	const { purpose, checklistItems } = safetyChecklistsFormData;

	const renderedChecklistItems = checklistItems?.filter((item) => item.text !== '');

	return (
		<>
			<h2 className="general-header">Please review your safety checklists.</h2>

			<p className="sub-grey-text mbtom-48">
				Once submitted your checklist will be sent to your nominated staff member for approval.
			</p>

			<div className="general-form-layout-wrapper">
				<div className="complaints-detail">
					<div className="detail-block">
						<h2 className="detail-heading">Title</h2>

						<p className="detail-info">{purpose}</p>
					</div>

					{renderedChecklistItems &&
						renderedChecklistItems.length > 0 &&
						renderedChecklistItems.map((item, index) => {
							return (
								<div key={index} className="detail-block">
									{item.text && (
										<>
											<h2 className="detail-heading">Item {index + 1}</h2>

											<p className="detail-info">{item.text}</p>
										</>
									)}
								</div>
							);
						})}
				</div>
			</div>

			<div className="general-divider"></div>

			<div className="form-two-button-group">
				<Button
					buttonIcon={<ArrowLeftIcon className="link-icon" />}
					className="btn-secondary edit-btn"
					onClick={() => setActiveStep('step1')}
				>
					Edit details
				</Button>

				<Button className="btn-primary submit-btn" onClick={formSubmitHandler}>
					Create checklist
				</Button>
			</div>
		</>
	);
};

export default StepTwo;
